import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/event/movie/logo.jpeg'
import _imports_1 from '@/assets/img/event/ueno/onlylive-logo.png'
import _imports_2 from '@/assets/img/event/movie/top-image-finish.png'
import _imports_3 from '@/assets/img/event/movie/movie-main-top.png'
import _imports_4 from '@/assets/img/event/movie/movie-title.png'
import _imports_5 from '@/assets/img/event/movie/top-benefits.png'
import _imports_6 from '@/assets/img/event/movie/rank-top-img.png'
import _imports_7 from '@/assets/img/event/movie/rank-second-img.png'
import _imports_8 from '@/assets/img/event/movie/rank-other-img.png'
import _imports_9 from '@/assets/img/event/ueno/notes-img.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-a1f563c6")

_pushScopeId("data-v-a1f563c6")
const _hoisted_1 = { class: "ueno-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lp-header" }, [
  /*#__PURE__*/_createVNode("a", { href: "https://kaikitaxi.jp" }, [
    /*#__PURE__*/_createVNode("img", {
      class: "kaiki-taxi-img",
      src: _imports_0
    })
  ]),
  /*#__PURE__*/_createVNode("img", {
    class: "onlylive-img",
    src: _imports_1
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "ueno-top-img" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "ueno-image",
    src: _imports_2
  })
], -1)
const _hoisted_4 = { class: "ueno-main" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "ueno-main-top-container" }, [
  /*#__PURE__*/_createVNode("div", { class: "ueno-main-top" }, [
    /*#__PURE__*/_createVNode("img", {
      class: "ueno-main-content",
      src: _imports_3
    }),
    /*#__PURE__*/_createVNode("p", { class: "ueno-main-content-bottom" }, [
      /*#__PURE__*/_createTextVNode("森野達弥が描く不気味痛快ホラー映画。"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("稲田直樹さん（アインシュタイン）、水野勝さん（BOYS AND MEN）、熊田曜子さんをはじめ、神田うのさん、木下ほうかさんなど"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("豪華芸能人の方々が出演される映画『怪奇タクシー』。"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("配信時間・人数などに応じて決定されるランキングで見事1位に輝いた方には、"),
      /*#__PURE__*/_createVNode("br", { class: "pc" }),
      /*#__PURE__*/_createTextVNode("セリフ有りで"),
      /*#__PURE__*/_createVNode("br", { class: "sp" }),
      /*#__PURE__*/_createTextVNode("出演できるだけでなく、ビジョン広告への出演も✨"),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("他、エキストラ賞も♪")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "ueno-photograph" }, [
    /*#__PURE__*/_createVNode("img", {
      class: "photograph-circle-img",
      src: _imports_0
    })
  ]),
  /*#__PURE__*/_createVNode("a", {
    class: "photograph-btn",
    href: "https://kaikitaxi.jp",
    target: "_brank"
  }, [
    /*#__PURE__*/_createVNode("p", { class: "entry-form-btn-content" }, "公式サイトはこちら")
  ]),
  /*#__PURE__*/_createVNode("p", { class: "entry-form-content" }, [
    /*#__PURE__*/_createVNode("span", null, "＼飛び込みオーディション参加可能／"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("onlylive配信をご希望の方はこちら")
  ]),
  /*#__PURE__*/_createVNode("a", {
    class: "photograph-btn",
    href: "https://onlylive.tokyo/talent#contact",
    target: "_brank"
  }, [
    /*#__PURE__*/_createVNode("p", { class: "entry-form-btn-content" }, "応募フォーム")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "event-info" }, [
    /*#__PURE__*/_createVNode("p", { class: "event-info-title" }, "『怪奇タクシー』情報"),
    /*#__PURE__*/_createVNode("a", {
      class: "event-info-link",
      href: "#benefits"
    }, "▼オーディション情報はこちら▼")
  ])
], -1)
const _hoisted_6 = { class: "event-ranking-body-section" }
const _hoisted_7 = { class: "ranking-section" }
const _hoisted_8 = { id: "info-detail" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "movie-title" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_4 })
], -1)
const _hoisted_10 = { class: "cast-list" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", null, "＜キャスト＞", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode("監督：夏目大一朗"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("脚本：岡本英郎"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("製作：映画『怪奇タクシー』製作委員会")
], -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { id: "benefits" }, [
  /*#__PURE__*/_createVNode("div", { class: "benefits-section" }, [
    /*#__PURE__*/_createVNode("div", { class: "benefits-top" }, [
      /*#__PURE__*/_createVNode("div", { class: "benefits-top-img" }, [
        /*#__PURE__*/_createVNode("img", {
          class: "benefits-img",
          src: _imports_5
        })
      ]),
      /*#__PURE__*/_createVNode("div", { class: "rank-top" }, [
        /*#__PURE__*/_createVNode("img", { src: _imports_6 })
      ]),
      /*#__PURE__*/_createVNode("div", { class: "benefit-common" }, [
        /*#__PURE__*/_createVNode("h2", null, "①映画『怪奇タクシー』出演権"),
        /*#__PURE__*/_createVNode("ul", { class: "benefits-content" }, [
          /*#__PURE__*/_createVNode("li", null, [
            /*#__PURE__*/_createTextVNode("・セリフ有り、エンドロール有り出演"),
            /*#__PURE__*/_createVNode("br"),
            /*#__PURE__*/_createTextVNode("※性別不問年齢18才以上の方が対象となります")
          ]),
          /*#__PURE__*/_createVNode("li", null, "・撮影日程：3月上旬"),
          /*#__PURE__*/_createVNode("li", null, "・ヘアメイク・衣装：ご自身でご用意ください"),
          /*#__PURE__*/_createVNode("li", null, "・撮影地：大阪近郊（もしくは東京近郊）"),
          /*#__PURE__*/_createVNode("li", null, [
            /*#__PURE__*/_createTextVNode("・食事・宿泊：ご負担なし"),
            /*#__PURE__*/_createVNode("br"),
            /*#__PURE__*/_createTextVNode("※出演の詳細、相談は2月28日までに受賞者へご連絡いたします")
          ]),
          /*#__PURE__*/_createVNode("li", null, [
            /*#__PURE__*/_createTextVNode("・交通費： ランキング5,000pt以上で20,000円の支給"),
            /*#__PURE__*/_createVNode("br"),
            /*#__PURE__*/_createTextVNode("※撮影が大阪近郊の場合のみ")
          ])
        ]),
        /*#__PURE__*/_createVNode("h2", null, [
          /*#__PURE__*/_createTextVNode("②映画コラボver."),
          /*#__PURE__*/_createVNode("br", { class: "sp" }),
          /*#__PURE__*/_createTextVNode("「onlylive」上野ビジョンCM出演権")
        ]),
        /*#__PURE__*/_createVNode("ul", { class: "benefits-content" }, [
          /*#__PURE__*/_createVNode("li", null, [
            /*#__PURE__*/_createTextVNode("・onlyliveの広告タレントとして、"),
            /*#__PURE__*/_createVNode("br"),
            /*#__PURE__*/_createTextVNode("上野広小路・御徒町付近の「上野ビジョン広告」に掲載")
          ]),
          /*#__PURE__*/_createVNode("li", null, "・掲出期間：2022年4月上旬〜1ヶ月(72回/日 放映予定)")
        ])
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "benefits-top" }, [
      /*#__PURE__*/_createVNode("div", { class: "rank-top" }, [
        /*#__PURE__*/_createVNode("img", { src: _imports_7 })
      ]),
      /*#__PURE__*/_createVNode("div", { class: "benefit-common" }, [
        /*#__PURE__*/_createVNode("h2", null, "エキストラ出演権"),
        /*#__PURE__*/_createVNode("ul", { class: "benefits-content" }, [
          /*#__PURE__*/_createVNode("li", null, [
            /*#__PURE__*/_createTextVNode("・台詞なし、エンドロール有り出演"),
            /*#__PURE__*/_createVNode("br"),
            /*#__PURE__*/_createTextVNode("※顔はしっかり写ります"),
            /*#__PURE__*/_createVNode("br"),
            /*#__PURE__*/_createTextVNode("※性別不問年齢18才以上の方が対象となります")
          ]),
          /*#__PURE__*/_createVNode("li", null, "・撮影日程：3月上旬"),
          /*#__PURE__*/_createVNode("li", null, "・ヘアメイク・衣装：ご自身でご用意ください"),
          /*#__PURE__*/_createVNode("li", null, [
            /*#__PURE__*/_createTextVNode("・交通費： ランキング5,000pt以上で20,000円の支給"),
            /*#__PURE__*/_createVNode("br"),
            /*#__PURE__*/_createTextVNode("※撮影が大阪近郊の場合のみ")
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "benefits-top" }, [
      /*#__PURE__*/_createVNode("div", { class: "rank-top" }, [
        /*#__PURE__*/_createVNode("img", { src: _imports_8 })
      ]),
      /*#__PURE__*/_createVNode("div", { class: "benefit-common" }, [
        /*#__PURE__*/_createVNode("h2", null, "「onlylive」上野ビジョンCM出演権"),
        /*#__PURE__*/_createVNode("ul", { class: "benefits-content" }, [
          /*#__PURE__*/_createVNode("li", null, [
            /*#__PURE__*/_createTextVNode("・onlyliveの広告タレントとして、"),
            /*#__PURE__*/_createVNode("br"),
            /*#__PURE__*/_createTextVNode("上野広小路・御徒町付近の「上野ビジョン広告」に掲載"),
            /*#__PURE__*/_createVNode("br"),
            /*#__PURE__*/_createTextVNode("※4〜5位はクレジット出演")
          ]),
          /*#__PURE__*/_createVNode("li", null, "・撮影日程：3月上旬〜中旬"),
          /*#__PURE__*/_createVNode("li", null, "・ヘアメイク・衣装：ご自身でご用意ください"),
          /*#__PURE__*/_createVNode("li", null, "・撮影場所：都内の撮影スタジオを予定しております"),
          /*#__PURE__*/_createVNode("li", null, "・掲出期間：2022年4月上旬〜1ヶ月(72回/日 放映予定)")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { class: "entry-form-content" }, [
  /*#__PURE__*/_createVNode("span", null, "＼飛び込みオーディション参加可能／"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("onlylive配信をご希望の方はこちら"),
  /*#__PURE__*/_createVNode("a", {
    class: "photograph-btn",
    href: "https://onlylive.tokyo/talent#contact",
    target: "_brank"
  }, [
    /*#__PURE__*/_createVNode("p", { class: "entry-form-btn-content" }, "応募フォーム")
  ])
], -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "notes-section" }, [
  /*#__PURE__*/_createVNode("div", { class: "notes-section-container" }, [
    /*#__PURE__*/_createVNode("div", { class: "notes-top-title" }, [
      /*#__PURE__*/_createVNode("img", { src: _imports_9 })
    ]),
    /*#__PURE__*/_createVNode("ul", { class: "notes-contents" }, [
      /*#__PURE__*/_createVNode("li", null, "・2022年2月6日0時00分以降通話開始分から、2022年2月26日23時59分59秒通話開始分までがランキングに加算されます。"),
      /*#__PURE__*/_createVNode("li", null, "・2022年2月26日23時59分59秒に通話が開始された場合、終了するまでがランキングに加算されます。（延長分も加算されます）"),
      /*#__PURE__*/_createVNode("li", null, "・最終ランキングの発表は、2022年2月27日を予定しております。"),
      /*#__PURE__*/_createVNode("li", null, "・ランキングの更新は1時間おきに行われます")
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "ueno-footer" }, [
    /*#__PURE__*/_createVNode("p", null, "© 2022 ILEO,inc.")
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Ranking = _resolveComponent("Ranking")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_Ranking, {
            event: _ctx.state.event,
            rankingUsers: _ctx.state.ranking,
            getRankingPath: "ranking_2201_kaiki",
            getEnableEventPath: "enable_2201_kaiki",
            isPreEvent: false,
            showRankingCount: 5
          }, null, 8, ["event", "rankingUsers"])
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode("div", _hoisted_10, [
          _hoisted_11,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.CastLists, (list) => {
            return (_openBlock(), _createBlock("p", { key: list }, [
              _createVNode("p", null, [
                _createTextVNode(_toDisplayString(list), 1),
                _hoisted_12
              ])
            ]))
          }), 128)),
          _hoisted_13
        ])
      ]),
      _hoisted_14,
      _hoisted_15,
      _hoisted_16
    ])
  ]))
})